/**
 * NHÃN BREADCRUMB DO TRANG TỰ ĐẶT — FR-032 / TC-14.
 *
 * ── Lỗi sinh ra tệp này ──────────────────────────────────────────────────
 * `AppShell` suy nhãn breadcrumb từ **đường dẫn**: `/domains/<id>` khớp
 * `startsWith('/domains')` nên `.crumbs strong` luôn đọc là "Tên miền". Nhưng
 * prototype nói khác, và nói rất rõ (`domain-detail.html`):
 *
 *     const crumb = document.querySelector('.crumbs strong');
 *     if (crumb) crumb.textContent = z.name;              // ← TÊN VÙNG
 *     document.title = z.name + ' · DNS records · DNSHub';
 *
 * Hai dòng ấy đi liền nhau vì chúng là **một yêu cầu**: chuyển tên miền thì cả
 * tiêu đề tab lẫn breadcrumb phải theo. SPA dựng đúng dòng thứ hai và bỏ dòng
 * thứ nhất, nên `TC-14` — vốn liệt kê *"tiêu đề, breadcrumb, bảng DNS, số bản
 * ghi, tiêu đề tab đều đổi"* — chỉ được đáp ứng bốn phần năm.
 *
 * Không bộ test cũ nào bắt được: test API không có breadcrumb, còn
 * `acceptance.test.tsx` dựng `DomainDetailPage` **không kèm `AppShell`** nên
 * thanh trên cùng không tồn tại trong cây DOM của nó.
 *
 * ── Vì sao là kho ngoài React thay vì context ────────────────────────────
 * Nơi ĐẶT (trang chi tiết) nằm sâu bên trong nơi ĐỌC (`AppShell`). Muốn dùng
 * context thì phải bọc thêm một provider quanh `AppShell` chỉ để truyền ngược
 * một chuỗi. `useSyncExternalStore` giải quyết đúng chiều dữ liệu này mà không
 * đụng vào cây component.
 */

import { useSyncExternalStore } from 'react';

let nhan: string | null = null;
const nguoiNghe = new Set<() => void>();

function phatTinHieu(): void {
  for (const goi of nguoiNghe) goi();
}

/** Trang đặt nhãn riêng; `null` để trả breadcrumb về nhãn suy từ đường dẫn. */
export function datNhanBreadcrumb(value: string | null): void {
  if (nhan === value) return;
  nhan = value;
  phatTinHieu();
}

function dangKy(goi: () => void): () => void {
  nguoiNghe.add(goi);
  return () => {
    nguoiNghe.delete(goi);
  };
}

const doc = (): string | null => nhan;

export function useNhanBreadcrumb(): string | null {
  // Tham số thứ ba là bản đọc cho lượt dựng phía máy chủ — ở đây luôn `null`.
  return useSyncExternalStore(dangKy, doc, () => null);
}
